import styled from 'styled-components';
import Image from 'next/image';
import Link from 'next/link';
import {
  Award,
  Bookmark,
  Gift,
  HelpCircle,
  Send,
  Tablet,
  User
} from 'styled-icons/feather';

import { media } from '@/themes';
import Menu from '@/components/menu';
import CTACard from '@/components/cta-card';
import Paragraph from '@/components/paragraph';

const MenuContainer = styled.ul`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  list-style: none;
  margin: 0;
  max-width: 100vw;
  padding: 0;

  ${media.sm`
    align-items: flex-start;
    background: ${props => props.theme.colors.background.card};
    border-radius: .25em;
    box-shadow: ${props => props.theme.shadows.hover};
    display: ${props => props.showMenu ? 'flex' : 'none'};
    flex-direction: column;
    left: 0;
    margin: 1em;
    padding-bottom: .5em;
    position: absolute;
    top: 0;
    width: calc(100vw - 2em);
  `};
`;

const IconContainer = styled.div`
  background-color: rgba(0, 0, 0, .05);
  border-radius: 50%;
  height: 2em;
  margin-right: .5em;
  overflow: hidden;
  padding: .5em;
  width: 2em;

  &.mobile-only {
    display: none;

    ${media.sm`
      display: block;
    `};
  }

  > img, > div, svg {
    display: block !important;
  }

  svg {
    stroke-width: 2;
  }
`;

const Item = styled.li`
  color: ${props => props.theme.colors.typography.primary};
  text-transform: uppercase;

  ${media.sm`
    flex-grow: 1;
    width: 100%;
  `};

  a {
    align-items: center;
    display: flex;
    color: #7D759A;
    padding: .5em 1em;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      text-decoration: none;
    }
  }

  & + & {
    margin-left: 2em;

    ${media.sm`
      margin: 0;
    `};
  }
`;

const NavbarItems = ({ onToggle, showMenu }) => {
  return (
    <MenuContainer showMenu={showMenu}>
      <Item>
        <Menu title="Products">
          <CTACard
            icon={<Tablet />}
            isMenu
            onClick={onToggle}
            to="/"
            title="Bidali App"
            mainColor="#DD5184"
            secondaryColor="#4B4DF1">
            <Paragraph>Send money anywhere and earn instant cash back.</Paragraph>
          </CTACard>
          <CTACard
            icon={<Gift />}
            isMenu
            onClick={onToggle}
            to="https://spend.bidali.com/"
            title="Buy Gift Cards"
            mainColor="#59B2D3"
            secondaryColor="#67E5A6">
            <Paragraph>Buy gift cards from thousands of top brands around the globe.</Paragraph>
          </CTACard>
        </Menu>
      </Item>
      <Item>
        <Menu title="Company">
          <Link href="/about">
            <a onClick={onToggle}>
              <IconContainer>
                <Image alt="Bidali" height={32} src="/images/favicon-32x32.png" width={32} />
              </IconContainer>
              About Bidali
            </a>
          </Link>
          <Link href="/careers">
            <a onClick={onToggle}>
              <IconContainer><User /></IconContainer>
              Careers
            </a>
          </Link>
          <Link href="/press">
            <a onClick={onToggle}>
              <IconContainer><Award /></IconContainer>
              Press
            </a>
          </Link>
          <Link href="/contact">
            <a onClick={onToggle}>
              <IconContainer><Send /></IconContainer>
              Contact
            </a>
          </Link>
          <Link href="/blog">
            <a onClick={onToggle}>
              <IconContainer><Bookmark /></IconContainer>
              Our blog
            </a>
          </Link>
        </Menu>
      </Item>
      <Item>
        <Link href="https://support.bidali.com">
          <a onClick={onToggle}>
            <IconContainer className="mobile-only"><HelpCircle /></IconContainer>
            Support
          </a>
        </Link>
      </Item>
    </MenuContainer>
  );
};

export default NavbarItems;
